import { localStorage } from 'dibs-browser-storage';
import { trackEvent } from 'dibs-tracking';
import SV from 'server-vars';

const TRACKING_CATEGORY = 'trade onboarding';
const VIEW_COUNT_LOCAL_STORAGE_KEY = 'TRADE_GENERAL_ONBOARDING_MODAL_VIEW_COUNT';
const CONFIRMATION_STEP_LABEL = 'confirmation page';

const getViewCount = () => localStorage.getItem(VIEW_COUNT_LOCAL_STORAGE_KEY) || 0;

export function hasSeenTradeGeneralOnboarding() {
    return getViewCount() > 0;
}

export function logTradeGeneralOnboardingView() {
    localStorage.setItem(VIEW_COUNT_LOCAL_STORAGE_KEY, getViewCount() + 1);
    trackEvent({
        action: 'general trade modal displayed',
        category: TRACKING_CATEGORY,
        label: 'none',
    });
}

export function trackTopCategorySelection(topCategory) {
    trackEvent({
        action: 'category selected',
        category: TRACKING_CATEGORY,
        label: topCategory,
    });
}

export function trackSubcategorySelection(subcategory) {
    trackEvent({
        action: 'subcategory selected',
        category: TRACKING_CATEGORY,
        label: subcategory,
    });
}

export function trackBudgetSelection(budget) {
    trackEvent({
        action: 'budget selected',
        category: TRACKING_CATEGORY,
        label: budget,
    });
}

export function trackContinueClick() {
    trackEvent({
        action: 'continue clicked',
        category: TRACKING_CATEGORY,
        label: 'none',
    });
}

export function trackBackClick({ pageNumber } = {}) {
    trackEvent({
        action: 'back clicked',
        category: TRACKING_CATEGORY,
        label: `page ${pageNumber}`,
    });
}

export function trackTimeframeSelection(timeframe) {
    trackEvent({
        action: 'timeline selected',
        category: TRACKING_CATEGORY,
        label: timeframe,
    });
}

export function trackSourcingSubmit() {
    trackEvent({
        action: 'submit sourcing request clicked',
        category: TRACKING_CATEGORY,
        label: 'none',
    });
}

export function trackSubmitAnotherRequestClick() {
    trackEvent({
        action: 'submit another request clicked',
        category: TRACKING_CATEGORY,
        label: CONFIRMATION_STEP_LABEL,
    });
}

export function trackNewCustomClick() {
    trackEvent({
        action: 'shop n&c clicked',
        category: TRACKING_CATEGORY,
        label: CONFIRMATION_STEP_LABEL,
    });
}

export function trackReturnToPageClick() {
    trackEvent({
        action: 'return to page clicked',
        category: TRACKING_CATEGORY,
        label: CONFIRMATION_STEP_LABEL,
    });
}

export function isMobile() {
    return SV.get('settings.isMobile') || false;
}

export function isUserTypeTrade() {
    return SV.get('settings.isUserTypeTrade') || false;
}
